import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    scene: {
      perspective: 600,
      '&:hover': {
        '& > *': {
          transform: 'rotateY(180deg)',
        },
      },
    },
    flipper: {
      height: '100%',
      transition: 'transform 0.8s',
      transitionDelay: '250ms',
      transformStyle: 'preserve-3d',
      '& > *': {
        position: 'absolute',
        height: '100%',
        width: '100%',
        backfaceVisibility: 'hidden',
      },
      '& > *:last-child': {
        transform: 'rotateY(180deg)',
      },
    },
  }),
);

export default useStyles;
